import { Add, Delete } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField } from '@mui/material';
import { Control, Controller, useFieldArray } from 'react-hook-form';

interface PortfolioSectionProps {
    control: Control<any, any>;
    readOnly?: boolean;
}
export const PortfolioSection = ({ control, readOnly = false }: PortfolioSectionProps) => {
    /* ******************** Hooks ******************** */
    const {
        fields,
        remove,
        append
    } = useFieldArray({
        control,
        name: 'Portfolio'
    })
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleAdd = () => {
        append('')
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>{
            fields.map( (field, index) => (
                <Grid key={field.id} item xs display={"flex"} flexDirection={"column"} gap={1}>
                    <Grid display={"flex"} flexDirection={"row"} gap={2}> 
                        <Controller 
                            name={`Portfolio.${index}`}
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                <TextField
                                    {...field}
                                    placeholder='Add a link to your portfolio'
                                    sx={{flex: 12}}
                                    // error={hasErrors(field.name, errors)}\
                                />
                            )}                                    
                        /> 
                        <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                                                <Box>
                                                    <IconButton onClick={ () => remove(index)}>
                                                        <Delete color='error'/>
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                        </Grid>    
                                    </Grid>
                                ))
                            } 
            {!readOnly && 
                <Grid item display={"flex"} flexDirection={"row"}>
                    <Button color='primary'  onClick={handleAdd} >
                        <Add fontSize='small' sx={{marginRight: 0.5}}/>Add portfolio
                    </Button> 
            </Grid>}
        </>
    )
}